<template>
  <div class="masterialBox">
    <div class="content" style="background: #fff;">
      <div style="display: flex;width: 100%;justify-content: space-between;">
        <div>
          <Button type="primary" @click="handleAdd()">新建物资管理</Button>
          <Button style="margin-left: 15px" @click="openClass">分类管理</Button>
          <Button style="margin-left: 15px" @click="addRecord">新增维修保养记录</Button>
        </div>
        <Input
          search
          enter-button
          placeholder=" 请输入名称/编号/用途/型号/部门/位置"
          v-model="fileNameOrTag"
          @on-search="getDangerPlan(1)"
          style="width: 300px"
        />
        <!--<Button type="primary" icon="ios-search" slot="append" @click="getDangerPlan(1)"></Button>-->
      </div>
      <div style="margin-top: 20px;">
        <Table :columns="columns" :data="data">
          <template slot-scope="{ row }" slot="num">
            <el-link type="primary" size="mini" @click.native.prevent="showData(row)">
              <span>{{ row.num }}</span>
            </el-link>
          </template>
          <template slot-scope="{ row }" slot="pdDate">
            <span>{{ row.pdDate | timeFilter }}</span>
          </template>
          <template slot-scope="{ row }" slot="usedDate">
            <span>{{ row.usedDate | timeFilter }}</span>
          </template>
          <template slot-scope="{ row }" slot="classifyName">
            <strong>{{ row.suppliesClassifyVo.classifyName }}</strong>
          </template>
          <template slot-scope="{ row }" slot="cycleStatus">
            <el-tag type="success" size="small" v-if="row.cycleStatus == '0'">已投用</el-tag>
            <el-tag type="primary" size="small" v-if="row.cycleStatus == '1'">库存中</el-tag>
            <el-tag type="danger" size="small" v-if="row.cycleStatus == '2'">报废</el-tag>
          </template>
          <template slot-scope="{ row }" slot="status">
            <el-tag type="success" size="small" v-if="row.status == '0'">完好</el-tag>
            <el-tag type="danger" size="small" v-if="row.status == '1'">维修</el-tag>
          </template>
          <template slot-scope="{ row }" slot="days">
            <el-tag type="success" v-if="row.days >= 30" size="small">剩余{{ row.days }}天</el-tag>
            <el-tag type="danger" v-else-if="row.days < 0" size="small">逾期{{ row.days * -1 }}天</el-tag>
            <el-tag type="danger" v-else-if="row.days > 0 && row.days <= 30" size="small">逾期{{ row.days }}天</el-tag>
          </template>
          <template slot-scope="{ row }" slot="action">
            <el-link type="primary" size="small" @click="handChange(row)" style="margin-right: 5px">编辑</el-link>|
            <el-link type="danger" size="small" @click="handleDel(row)">删除</el-link>
          </template>
        </Table>
        <Page
          style="float: right;margin-top: 10px;"
          :total="total"
          :page-size="pageSize"
          @on-change="getDangerPlan"
        />
      </div>
    </div>
    <el-drawer :visible.sync="drawer" direction="rtl" :before-close="handleClose" :show-close="false" size="60%">
      <div slot="title" class="drawerTitle">
        <p>名称：{{ infoForm.name }}
          <i class="el-icon-circle-close" @click="handleClose"></i>
        </p>
        <div class="tWord">
          <div><p>物资名称</p><span>{{ infoForm.num }}</span></div>
          <div><p>物资分类</p><span v-if="infoForm.suppliesClassifyVo">{{ infoForm.suppliesClassifyVo.classifyName }}</span></div>
          <div><p>创建时间</p><span>{{ infoForm.gmtCreate }}</span></div>
        </div>
      </div>
      <div class="drawerBody">
        <el-tabs v-model="activeName">
          <el-tab-pane label="物资详情" name="a"></el-tab-pane>
          <el-tab-pane label="保养维修记录" name="b"></el-tab-pane>
        </el-tabs>
        <div class="bodyInner">
          <!-- 详情 -->
          <el-form
            :inline="true"
            :model="infoForm"
            class="demo-form-inline"
            style="background-color: white"
            v-show="activeName === 'a'"
          >
            <el-form-item label="物资编号：" style="width: 40%;margin-left: 8%">
              <span size="small">{{infoForm.num}}</span>
            </el-form-item>
            <el-form-item label="物资名称：" style="width: 40%;margin-left: 5%">
              <span size="small">{{infoForm.name}}</span>
            </el-form-item>
            <el-form-item label="物资用途：" style="width: 40%;margin-left: 8%">
              <span size="small">{{infoForm.purpose}}</span>
            </el-form-item>
            <el-form-item label="物资型号：" style="width: 40%;margin-left: 5%">
              <span size="small">{{infoForm.model}}</span>
            </el-form-item>
            <el-form-item label="负责部门：" style="width: 40%;margin-left: 8%">
              <span size="small">{{infoForm.depName}}</span>
            </el-form-item>
            <el-form-item label="物资分类：" style="width: 40%;margin-left: 5%">
              <span size="small">{{infoForm.suppliesClassifyVo.classifyName}}</span>
            </el-form-item>
            <el-form-item label="存放位置：" style="width: 40%;margin-left: 8%">
              <span size="small">{{infoForm.position}}</span>
            </el-form-item>
            <el-form-item label="储存数量：" style="width: 40%;margin-left: 5%">
              <span size="small">{{infoForm.amount}}</span>
            </el-form-item>
            <el-form-item label="生产日期：" style="width: 40%;margin-left: 8%">
              <span size="small">{{infoForm.pdDate}}</span>
            </el-form-item>
            <el-form-item label="投用日期：" style="width: 40%;margin-left: 5%">
              <span size="small">{{infoForm.usedDate}}</span>
            </el-form-item>
            <el-form-item label="生命周期：" style="width: 40%;margin-left: 8%">
              <el-tag type="success" size="small" v-if="infoForm.cycleStatus == '0'">已投用</el-tag>
              <el-tag type="primary" size="small" v-if="infoForm.cycleStatus == '1'">库存中</el-tag>
              <el-tag type="danger" size="small" v-if="infoForm.cycleStatus == '2'">报废</el-tag>
            </el-form-item>
            <el-form-item label="状态：" style="width: 40%;margin-left: 5%">
              <el-tag type="success" size="small" v-if="infoForm.status == '0'">完好</el-tag>
              <el-tag type="danger" size="small" v-if="infoForm.status == '1'">维修</el-tag>
            </el-form-item>
            <el-form-item label="使用说明：" style="width: 90%;margin-left: 8%">
              <el-link
                v-for="(item1,index) in trainStuff"
                type="primary"
                :key="index"
                @click="download(item1)"
              >{{item1.name}}&nbsp;&nbsp;&nbsp;</el-link>
            </el-form-item>
          </el-form>
          <!-- 保养维修记录 -->
          <div class="innerBoxTable" style="padding: 15px" v-show="activeName === 'b'">
            <el-table :data="infoForm.keepMaintains || []" style="width: 100%">
              <el-table-column prop="type" label="分类">
                <template slot-scope="{ row }">
                  {{ row.type ? '维修' : '保养' }}
                </template>
              </el-table-column>
              <el-table-column prop="name" label="名称" />
              <el-table-column prop="startTime" label="开始时间">
                <template slot-scope="{ row }">
                  {{ row.startTime | timeFilter }}
                </template>
              </el-table-column>
              <el-table-column prop="endTime" label="结束时间">
                <template slot-scope="{ row }">
                  {{ row.endTime | timeFilter }}
                </template>
              </el-table-column>
              <el-table-column prop="nextKeepTime" label="下次保养（维修）时间">
                <template slot-scope="{ row }">
                  {{ row.nextKeepTime | timeFilter }}
                </template>
              </el-table-column>
              <el-table-column prop="content" label="内容" show-overflow-tooltip />
              <el-table-column prop="inChargeUserName" label="责任人" />
              <el-table-column prop="picture" label="附图">
                <template slot-scope="{ row }">
                  <el-image v-if="row.picture"
                    style="width: 50px; height: 50px"
                    :src="host + row.picture" 
                    :preview-src-list="[host + row.picture]">
                  </el-image>
                  <span v-else></span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="操作">
                <template slot-scope="{ row }">
                  <el-link :underline="false" type="danger" @click="drawerDeleteBtn(row)">删除</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-drawer>

    <!-- 分类管理的弹窗 -->
    <el-dialog title="分类管理" :visible.sync="dialogTableVisible" top="8vh">
      <el-button size="small" type="primary" @click="addClassify">新增</el-button>
      <el-table :data="gridData" max-height="600">
        <el-table-column property="gmtCreate" label="创建日期"></el-table-column>
        <el-table-column property="classifyName" label="分类名称"></el-table-column>
        <el-table-column property="address" label="操作">
          <template slot-scope="scope">
            <el-link type="primary" @click="editClassify(scope.row)">编辑</el-link> | 
            <el-link type="danger" @click="deleteClassify(scope.row.id)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { downLoadDocument } from "@/api/downLoad";
import { getClassList, addClassList, editClassList,
  deleteClassList, materialDetail, deleteMasterialRecord } from "@/api/processManager"
export default {
  data() {
    return {
      total: 0,
      pageSize: 10,
      currentPage: 1,
      pageTotal: 0,
      total: 0,
      fileNameOrTag: "",
      columns: [
        { title: "编号", slot: "num" },
        { title: "名称", key: "name" },
        { title: "用途", key: "purpose" },
        { title: "型号", key: "model", tooltip: true },
        { title: "负责部门", key: "depName" },
        { title: "生产日期", slot: 'pdDate' },
        { title: "投用时间", slot: 'usedDate' },
        { title: "分类", slot: "classifyName" },
        { title: "使用期限", slot: "days", align: "center", width: 100 },
        { title: "存放位置", key: "position" },
        { title: "生命周期", slot: "cycleStatus" },
        { title: "状态", slot: "status" },
        { title: "操作", slot: "action", align: "center", width: 150 }
      ],
      data: [],
      activeName: "a",
      infoForm: {
        suppliesClassifyVo: { classifyName: "" }
      },
      drawer: false,
      trainStuff: [],
      // 分类管理的数据
      gridData: [],
      dialogTableVisible: false,
      visible: false,
      className: '111'
    };
  },
  created() {},
  mounted: function() {
    this.getData();
  },
  methods: {
    showData(row) {
      // this.infoForm = row;
      
      materialDetail(row.id).then(res => {
        this.infoForm = res.body.data
        this.trainStuff = [];
        let files = JSON.parse(this.infoForm.suppliesFile);
        if (files) {
          for (var i = 0; i < files.length; i++) {
            let myFile = {};
            var file = files[i];
            myFile.response = {};
            myFile.response.data = file.url;
            myFile.name = file.fileName;
            this.trainStuff.push(myFile);
          }
        }
        this.drawer = true;
      })
    },
    handleClose() {
      this.drawer = false;
    },
    getNowDate() {
      let date = new Date();
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      return y + "-" + m + "-" + d;
    },
    DateDiff(sDate1) {
      //sDate1和 sDate2 是2002-12-18格式
      let sDate2 = this.getNowDate();
      var aDate, oDate1, oDate2, iDays;
      aDate = sDate1.split("-");
      oDate1 = new Date(aDate[1] + "-" + aDate[2] + "-" + aDate[0]); //转换为12-18-2002格式
      aDate = sDate2.split("-");
      oDate2 = new Date(aDate[1] + "-" + aDate[2] + "-" + aDate[0]);
      iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24); //把相差的毫秒数转换为天数
      let result = this.tab(sDate1, sDate2);
      if (result == 1) {
        return iDays ;
      } else {
        return -iDays;
      }
    },
    tab(date1, date2) {
      var oDate1 = new Date(date1);
      var oDate2 = new Date(date2);
      if (oDate1.getTime() > oDate2.getTime()) {
        return 1;
      } else {
        return 0;
      }
    },
    getData() {
      this.getDangerPlan(1);
    },
    getDangerPlan: function(page) {
      let param = {};
      param.limit = this.pageSize;
      param.curPage = page;
      param.searchParam = this.fileNameOrTag;
      this.componentsMoudel.httpRequest
        .getRequestHander(
          "/materials/list_all?limit=" +
            this.pageSize +
            "&curPage=" +
            page +
            "&searchParam=" +
            this.fileNameOrTag
        )
        .openLoad()
        .startPost(param)
        .then(res => {
          this.data = res.body.data;
          for (var i = 0; i < this.data.length; i++) {
            let lineTime = new Date(this.data[i].pdDate);
            lineTime.setMonth(lineTime.getMonth() + this.data[i].serviceLife);
            var planTime =
              lineTime.getFullYear() +
              "-" +
              ((lineTime.getMonth() < 9 ? "0" : "") +
                (lineTime.getMonth() + 1)) +
              "-" +
              (lineTime.getDate() < 10 ? "0" : "") +
              lineTime.getDate();
            let days = this.DateDiff(planTime);
            if (!days) {
              days = "剩余0天";
            }
            this.data[i].days = days;
          }
          this.currentPage = res.body.page;
          this.pageTotal = res.body.pageTotal;
          this.total = res.body.cum;
        });
    },
    handleAdd() {
      this.$router.push({
        path: "addMaterial"
      });
    },
    handChange(row) {
      this.$router.push({
        name: "addMaterial",
        params: { key: row }
      });
    },
    handleDel(row) {
      this.componentsMoudel.httpRequest
        .getRequestHander("/materials/delete/" + row.id)
        .openLoad()
        .startPost()
        .then(res => {
          this.$message({
            showClose: true,
            message: "删除成功",
            type: "success"
          });
          this.getData();
        });
    },
    // 下载文件
    download(item1) {
      console.log(item1)
      downLoadDocument(item1.response.data, item1.name)
    },
    // 分类的弹窗
    openClass() {
      getClassList().then(res => {
        console.log(res)
        this.gridData = res.body.data
        this.dialogTableVisible = true
      })
    },
    // 新增分类
    addClassify() {
      this.$prompt('请输入分类名称', '新增分类', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if(!value && value != 0) {
            this.$message.info('分类名称不能为空')
            return
          }
          addClassList({ classifyName: value }).then(res => {
            this.openClass()
            this.$message.success('新增成功')
          })
        }).catch(() => {
          return     
        });
    },
    // 编辑分类
    editClassify(val) {
      this.$prompt('请输入新的分类名称', val.classifyName, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if(!value && value != 0) {
            this.$message.info('分类名称不能为空')
            return
          }
          editClassList({id: val.id, classifyName: value}).then(res => {
            this.openClass()
            this.$message.success('编辑成功')
          })
        }).catch(() => {
          return     
        });
    },
    // 删除分类
    deleteClassify(id) {
      deleteClassList(id).then(res => {
        this.openClass()
        this.$message.success('删除成功')
      })
    },
    // 新增维修保养记录
    addRecord() {
      this.$router.push('addMasterialRecord')
    },
    // 抽屉维修保养删除按钮
    drawerDeleteBtn(row) {
      deleteMasterialRecord(row.id).then(res => {
        this.$message.success('删除成功')
        this.showData(this.infoForm)
      })
    }
  }
};
</script>

<style scoped>
/* .content {
  background-color: #ffffff;
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 10px;
  border: 1px solid #e9eef3;
} */
/* <!--         抽屉样式           --> */
.drawerTitle {
  box-shadow: 0px 5px 5px -5px black;
  height: 120px;
  padding: 0 15px
}
.drawerTitle > p {
  color: #000000;
  font-size: 18px;
  line-height: 55px;
}
.drawerTitle > p > i {
  font-size: 30px;
  float: right;
  margin: 15px 10px 0 0;
}
.drawerTitle > p > i:hover {
  color: #409EFF
}
.el-drawer__header {
  padding: 0 15px;
  margin-bottom: 0
}

/* 解决tab切换会有蓝色边框的问题 */ 
.masterialBox /deep/ .el-tabs__item:focus.is-active.is-focus:not(:active) {
box-shadow: none;
border-top-left-radius: 20px;
border-top-right-radius: 20px;
}

/*  */

.tWord {
  display: flex
}
.tWord div > p {
  font-size: 15px;
  line-height: 25px
}
.tWord div > span {
  color: #000000
}
.tWord div {
  width: 220px
}
.drawerBody {
  width: 100%;
  height: calc(100vh - 160px);
  background: rgb(247,247,247);
  overflow: hidden;
  padding: 10px 20px 20px;
}
.bodyInner {
  background: white;
  height: calc(100% - 60px);
  width: 100%;
  border: 1px solid #eaeaea;
  overflow: scroll;
}
</style>
